
import './style.css';

function App(props) {
  return (
    <div className="img-view"  onClick={()=>{
      if(props.text!==""){
        props.onClick(props.src, props.text);
      }
      
  }}    >
      
   
        <div className='img-txt'>{props.text}</div>



        <img id={props.id} className="img" src={props.src} 
                 
          alt={props.src}/>  


      </div>
    );
}

export default App;
